import { render, staticRenderFns } from "./user-preview.vue?vue&type=template&id=85c0fc8a&scoped=true&"
import script from "./user-preview.vue?vue&type=script&lang=js&"
export * from "./user-preview.vue?vue&type=script&lang=js&"
import style0 from "./user-preview.vue?vue&type=style&index=0&id=85c0fc8a&lang=scss&scoped=true&"
import style1 from "./user-preview.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c0fc8a",
  null
  
)

export default component.exports